import { render, staticRenderFns } from "./G.vue?vue&type=template&id=1b4dd870&scoped=true&"
import script from "./G.vue?vue&type=script&lang=js&"
export * from "./G.vue?vue&type=script&lang=js&"
import style0 from "./G.vue?vue&type=style&index=0&id=1b4dd870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4dd870",
  null
  
)

export default component.exports